/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FunctionalScope
 */
export interface FunctionalScope {
    /**
     * 
     * @type {string}
     * @memberof FunctionalScope
     */
    globalScopeHumanId: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionalScope
     */
    specificScopeHumanId: string;
}

/**
 * Check if a given object implements the FunctionalScope interface.
 */
export function instanceOfFunctionalScope(value: object): value is FunctionalScope {
    if (!('globalScopeHumanId' in value) || value['globalScopeHumanId'] === undefined) return false;
    if (!('specificScopeHumanId' in value) || value['specificScopeHumanId'] === undefined) return false;
    return true;
}

export function FunctionalScopeFromJSON(json: any): FunctionalScope {
    return FunctionalScopeFromJSONTyped(json, false);
}

export function FunctionalScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionalScope {
    if (json == null) {
        return json;
    }
    return {
        
        'globalScopeHumanId': json['globalScopeHumanId'],
        'specificScopeHumanId': json['specificScopeHumanId'],
    };
}

export function FunctionalScopeToJSON(value?: FunctionalScope | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'globalScopeHumanId': value['globalScopeHumanId'],
        'specificScopeHumanId': value['specificScopeHumanId'],
    };
}

